import { LogChannel, LoggingMessageInterface } from '@rx-applications/shared/logging';

export enum EventName {
  ClickedOnReset = 'ClickedOnReset',
  LandedOnLoginScreen = 'LandedOnLoginScreen',
  LoginSuccess = 'LoginSuccess',
  LoginFailed = 'LoginFailed',
  ForceChangePassword = 'ForceChangePassword',
}

export const LogChannelMessageMappings = {
  [EventName.ClickedOnReset]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.ClickedOnReset, props: {}, type: null } as LoggingMessageInterface,
  },
  [EventName.ForceChangePassword]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.ForceChangePassword, props: {}, type: null } as LoggingMessageInterface,
  },
  [EventName.LandedOnLoginScreen]: {
    channels: [LogChannel.Amplitude, LogChannel.Intercom, LogChannel.Datadog],
    message: { name: EventName.LandedOnLoginScreen, props: {}, type: 'action' } as LoggingMessageInterface,
  },
  [EventName.LoginSuccess]: {
    channels: [LogChannel.Amplitude, LogChannel.Datadog, LogChannel.Intercom],
    message: { name: EventName.LoginSuccess, props: {}, type: 'action' } as LoggingMessageInterface,
  },
  [EventName.LoginFailed]: {
    channels: [LogChannel.Amplitude, LogChannel.Datadog, LogChannel.Intercom],
    message: { name: EventName.LoginFailed, props: {}, type: 'error' } as LoggingMessageInterface,
  },
};
